import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useTaskList from 'components/onboarding/useTaskList';
import { setSlideKey, setBubbleSeenByUser, setTaskButtonRef } from 'store/onboarding';

import Button from '@material-ui/core/Button';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { Theme } from 'styles/ThemeTyping';

interface Props {
  onOnboardingButtonClick: (_buttonName: string) => void;
}

function OnboardingTaskButton({ onOnboardingButtonClick }: Props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  const taskButtonRef = useRef(null);
  const taskList = useTaskList();
  const [taskTitle, setTaskTitle] = useState('');
  const onScreenTask = taskList && taskList.find(t => location.pathname.includes(t.pageStartUrl));

  const onboardingState = useSelector((state: any) => state.onboarding);

  const { bubbleSeenByUser, bubbleOpen, buttonName } = onboardingState;

  const handleToggleBubbleOpenOnTask = () => {
    !bubbleSeenByUser && dispatch(setBubbleSeenByUser());
    const onScreenTaskId = onScreenTask && onScreenTask.id;
    onScreenTaskId && dispatch(setSlideKey(onScreenTaskId));
    onOnboardingButtonClick('task');
  };

  useEffect(() => {
    if (!onScreenTask) {
      setTaskTitle('');
    } else {
      setTaskTitle(onScreenTask.title);
    }
  }, [location.pathname, onScreenTask]);

  useEffect(() => {
    dispatch(setTaskButtonRef(taskButtonRef));
  }, []);

  return (
    <>
      {taskTitle && (
        <Button
          onClick={handleToggleBubbleOpenOnTask}
          className={classNames(
            classes.taskButton,
            bubbleOpen && buttonName === 'task' && classes.activeButton,
          )}
          ref={taskButtonRef}
        >
          {taskTitle}
          <InfoOutlinedIcon className={classes.info} />
        </Button>
      )}
    </>
  );
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    info: {
      color: theme.palette.grey[400],
      maxHeight: 20,
      maxWidth: 20,
      marginLeft: theme.spacing(0.5),
    },
    taskButton: {
      ...theme.typography.body2,
      textTransform: 'none',
      padding: theme.spacing(),
      marginRight: theme.spacing(2),
      '&:hover': {
        boxShadow: theme.shadows[5],
      },
    },
    activeButton: {
      boxShadow: theme.shadows[5],
    },
  };
});

export default OnboardingTaskButton;
